import React, { useCallback, useMemo, useState } from "react";
import {
  FaSearch,
  FaTimesCircle,
  FaUserShield,
  FaUserTie,
  FaUserFriends,
  FaNetworkWired,
  FaCheckCircle,
  FaLightbulb,
  FaRobot,
  FaPaperPlane,
  FaQuestionCircle,
  FaMoneyCheckAlt,
} from "react-icons/fa";
import { RAW_MANUAL_SECTIONS } from "../data/manualSections";

const encodeSvg = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const CATEGORY_ILLUSTRATIONS = {
  "Início": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradInicio" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#e0f2fe" />
          <stop offset="100%" stop-color="#bfdbfe" />
        </linearGradient>
        <linearGradient id="cardInicio" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#2563eb" stop-opacity="0.25" />
          <stop offset="100%" stop-color="#60a5fa" stop-opacity="0.5" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradInicio)" />
      <rect x="32" y="36" width="120" height="20" rx="10" fill="white" opacity="0.9" />
      <rect x="32" y="68" width="200" height="70" rx="16" fill="url(#cardInicio)" />
      <circle cx="220" cy="52" r="18" fill="#1d4ed8" opacity="0.3" />
      <circle cx="250" cy="112" r="36" fill="#3b82f6" opacity="0.25" />
      <rect x="52" y="84" width="72" height="8" rx="4" fill="white" opacity="0.9" />
      <rect x="52" y="100" width="96" height="8" rx="4" fill="white" opacity="0.7" />
    </svg>
  `),
  "Operações": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradOperacoes" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#dcfce7" />
          <stop offset="100%" stop-color="#bbf7d0" />
        </linearGradient>
        <linearGradient id="cardOperacoes" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#047857" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#34d399" stop-opacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradOperacoes)" />
      <rect x="28" y="30" width="92" height="92" rx="20" fill="url(#cardOperacoes)" />
      <rect x="136" y="44" width="60" height="12" rx="6" fill="#064e3b" opacity="0.45" />
      <rect x="136" y="66" width="120" height="12" rx="6" fill="#047857" opacity="0.55" />
      <rect x="136" y="88" width="150" height="12" rx="6" fill="#10b981" opacity="0.45" />
      <rect x="136" y="110" width="96" height="12" rx="6" fill="#047857" opacity="0.35" />
      <circle cx="80" cy="76" r="20" fill="#ecfdf5" opacity="0.9" />
      <path d="M70 76h20" stroke="#10b981" stroke-width="4" stroke-linecap="round" />
      <path d="M80 66v20" stroke="#10b981" stroke-width="4" stroke-linecap="round" />
    </svg>
  `),
  "Automação": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradAutomacao" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ede9fe" />
          <stop offset="100%" stop-color="#ddd6fe" />
        </linearGradient>
        <linearGradient id="cardAutomacao" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#6d28d9" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#a855f7" stop-opacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradAutomacao)" />
      <rect x="40" y="36" width="240" height="88" rx="24" fill="white" opacity="0.85" />
      <rect x="60" y="52" width="88" height="56" rx="16" fill="url(#cardAutomacao)" />
      <rect x="160" y="60" width="100" height="8" rx="4" fill="#6d28d9" opacity="0.5" />
      <rect x="160" y="80" width="120" height="8" rx="4" fill="#6d28d9" opacity="0.35" />
      <rect x="160" y="100" width="72" height="8" rx="4" fill="#6d28d9" opacity="0.3" />
      <circle cx="230" cy="48" r="18" fill="#a855f7" opacity="0.3" />
      <circle cx="90" cy="84" r="12" fill="#ede9fe" />
      <path d="M86 84h8" stroke="#ede9fe" stroke-width="3" stroke-linecap="round" />
    </svg>
  `),
  "Administração": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradAdministracao" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fee2e2" />
          <stop offset="100%" stop-color="#fecaca" />
        </linearGradient>
        <linearGradient id="cardAdministracao" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#b91c1c" stop-opacity="0.55" />
          <stop offset="100%" stop-color="#f87171" stop-opacity="0.35" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradAdministracao)" />
      <rect x="32" y="36" width="120" height="24" rx="12" fill="white" opacity="0.9" />
      <rect x="32" y="72" width="256" height="72" rx="20" fill="white" opacity="0.85" />
      <rect x="48" y="88" width="72" height="40" rx="12" fill="url(#cardAdministracao)" />
      <rect x="132" y="96" width="60" height="8" rx="4" fill="#b91c1c" opacity="0.5" />
      <rect x="132" y="112" width="90" height="8" rx="4" fill="#b91c1c" opacity="0.35" />
      <circle cx="240" cy="96" r="22" fill="#fca5a5" opacity="0.6" />
      <path d="M230 94h20" stroke="#7f1d1d" stroke-width="3" stroke-linecap="round" />
      <path d="M240 84v20" stroke="#7f1d1d" stroke-width="3" stroke-linecap="round" />
    </svg>
  `),
  "Financeiro": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradFinanceiro" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ecfdf5" />
          <stop offset="100%" stop-color="#d1fae5" />
        </linearGradient>
        <linearGradient id="cardFinanceiro" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#047857" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#10b981" stop-opacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradFinanceiro)" />
      <rect x="36" y="44" width="248" height="72" rx="20" fill="white" opacity="0.85" />
      <rect x="52" y="56" width="112" height="48" rx="14" fill="url(#cardFinanceiro)" />
      <rect x="176" y="56" width="92" height="12" rx="6" fill="#059669" opacity="0.6" />
      <rect x="176" y="74" width="128" height="12" rx="6" fill="#34d399" opacity="0.4" />
      <rect x="176" y="92" width="72" height="12" rx="6" fill="#047857" opacity="0.3" />
      <circle cx="256" cy="52" r="18" fill="#10b981" opacity="0.25" />
      <path d="M76 72c12 12 32 12 44 0" stroke="#ecfeff" stroke-width="4" stroke-linecap="round" />
      <path d="M76 84c8 8 20 8 28 0" stroke="#ecfeff" stroke-width="4" stroke-linecap="round" />
    </svg>
  `),
  "Patrimônio": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradPatrimonio" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#f8fafc" />
          <stop offset="100%" stop-color="#e2e8f0" />
        </linearGradient>
        <linearGradient id="cardPatrimonio" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#1e3a8a" stop-opacity="0.55" />
          <stop offset="100%" stop-color="#3b82f6" stop-opacity="0.35" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradPatrimonio)" />
      <rect x="44" y="36" width="96" height="96" rx="24" fill="url(#cardPatrimonio)" />
      <rect x="160" y="48" width="116" height="14" rx="7" fill="#1d4ed8" opacity="0.45" />
      <rect x="160" y="70" width="140" height="14" rx="7" fill="#2563eb" opacity="0.35" />
      <rect x="160" y="92" width="88" height="14" rx="7" fill="#1d4ed8" opacity="0.3" />
      <rect x="160" y="114" width="72" height="14" rx="7" fill="#1d4ed8" opacity="0.25" />
      <path d="M68 68h48v32H68z" fill="white" opacity="0.9" />
      <path d="M72 88h40" stroke="#1d4ed8" stroke-width="4" stroke-linecap="round" />
      <circle cx="220" cy="116" r="18" fill="#93c5fd" opacity="0.6" />
    </svg>
  `),
  "Estoques": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradEstoques" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fff7ed" />
          <stop offset="100%" stop-color="#fed7aa" />
        </linearGradient>
        <linearGradient id="cardEstoques" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#f97316" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#fb923c" stop-opacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradEstoques)" />
      <rect x="36" y="54" width="248" height="68" rx="18" fill="white" opacity="0.85" />
      <rect x="52" y="68" width="96" height="40" rx="12" fill="url(#cardEstoques)" />
      <rect x="160" y="70" width="108" height="12" rx="6" fill="#c2410c" opacity="0.5" />
      <rect x="160" y="92" width="132" height="12" rx="6" fill="#f97316" opacity="0.35" />
      <circle cx="108" cy="88" r="10" fill="#fff7ed" />
      <path d="M96 100h24" stroke="#fed7aa" stroke-width="4" stroke-linecap="round" />
      <circle cx="244" cy="56" r="18" fill="#f97316" opacity="0.3" />
    </svg>
  `),
  "Cadastros": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradCadastros" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#eef2ff" />
          <stop offset="100%" stop-color="#e0e7ff" />
        </linearGradient>
        <linearGradient id="cardCadastros" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#4338ca" stop-opacity="0.55" />
          <stop offset="100%" stop-color="#6366f1" stop-opacity="0.35" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradCadastros)" />
      <rect x="44" y="40" width="232" height="80" rx="22" fill="white" opacity="0.9" />
      <rect x="60" y="56" width="96" height="48" rx="14" fill="url(#cardCadastros)" />
      <rect x="172" y="60" width="108" height="10" rx="5" fill="#4f46e5" opacity="0.45" />
      <rect x="172" y="78" width="132" height="10" rx="5" fill="#4338ca" opacity="0.35" />
      <rect x="172" y="96" width="84" height="10" rx="5" fill="#6366f1" opacity="0.3" />
      <circle cx="240" cy="104" r="16" fill="#818cf8" opacity="0.6" />
      <path d="M80 76h52" stroke="#eef2ff" stroke-width="4" stroke-linecap="round" />
      <path d="M80 92h36" stroke="#e0e7ff" stroke-width="4" stroke-linecap="round" />
    </svg>
  `),
  "Pessoas": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradPessoas" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fdf4ff" />
          <stop offset="100%" stop-color="#fae8ff" />
        </linearGradient>
        <linearGradient id="cardPessoas" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#7c3aed" stop-opacity="0.55" />
          <stop offset="100%" stop-color="#a855f7" stop-opacity="0.35" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradPessoas)" />
      <rect x="44" y="44" width="232" height="72" rx="24" fill="white" opacity="0.9" />
      <rect x="64" y="56" width="96" height="48" rx="16" fill="url(#cardPessoas)" />
      <circle cx="208" cy="80" r="22" fill="#c4b5fd" opacity="0.6" />
      <circle cx="246" cy="80" r="16" fill="#a855f7" opacity="0.4" />
      <path d="M208 94c10-8 22-8 32 0" stroke="#7c3aed" stroke-width="4" stroke-linecap="round" opacity="0.35" />
      <circle cx="112" cy="80" r="12" fill="#ede9fe" />
      <path d="M108 80h8" stroke="#ede9fe" stroke-width="3" stroke-linecap="round" />
      <path d="M92 104h40" stroke="#c4b5fd" stroke-width="4" stroke-linecap="round" opacity="0.8" />
    </svg>
  `),
  "Inteligência": encodeSvg(`
    <svg width="320" height="160" viewBox="0 0 320 160" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradInteligencia" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fdf2f8" />
          <stop offset="100%" stop-color="#fce7f3" />
        </linearGradient>
        <linearGradient id="cardInteligencia" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#db2777" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#ec4899" stop-opacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="320" height="160" rx="28" fill="url(#gradInteligencia)" />
      <rect x="36" y="44" width="248" height="72" rx="24" fill="white" opacity="0.85" />
      <rect x="56" y="56" width="96" height="48" rx="16" fill="url(#cardInteligencia)" />
      <circle cx="240" cy="80" r="36" fill="#ec4899" opacity="0.2" />
      <circle cx="240" cy="80" r="20" fill="#fdf2f8" opacity="0.9" />
      <path d="M236 80h8" stroke="#ec4899" stroke-width="3" stroke-linecap="round" />
      <path d="M240 76v8" stroke="#ec4899" stroke-width="3" stroke-linecap="round" />
      <rect x="168" y="62" width="104" height="12" rx="6" fill="#db2777" opacity="0.35" />
      <rect x="168" y="86" width="92" height="12" rx="6" fill="#ec4899" opacity="0.3" />
    </svg>
  `),
};

const MANUAL_SECTIONS = RAW_MANUAL_SECTIONS.map((section) => ({
  ...section,
  illustration: CATEGORY_ILLUSTRATIONS[section.category] || null,
}));

const assistantQuickPrompts = [
  {
    id: "platform-overview",
    label: "Conhecer a plataforma",
    query: "Quais módulos compõem a plataforma e como navegar por eles?",
  },
  {
    id: "request-lifecycle",
    label: "Fluxo de solicitação",
    query: "Quais etapas devo seguir para abrir, acompanhar e concluir uma solicitação?",
  },
  {
    id: "hr-manage",
    label: "Cadastrar colaborador",
    query: "Como cadastrar ou atualizar um colaborador no módulo de Recursos Humanos?",
  },
  {
    id: "hr-reports",
    label: "Relatórios de RH",
    query: "Como gerar CSV ou PDF com os dados de colaboradores?",
  },
  {
    id: "finance-conciliation",
    label: "Conciliar lançamentos",
    query: "Como concluir uma conciliação bancária no módulo Financeiro?",
  },
  {
    id: "inventory-movement",
    label: "Registrar movimentação",
    query: "Como registrar uma movimentação de estoque?",
  },
  {
    id: "asset-maintenance",
    label: "Acompanhar manutenções",
    query: "Como controlar manutenções no módulo de Patrimônio?",
  },
  {
    id: "cadastros-export",
    label: "Exportar cadastros",
    query: "Como exportar relatórios personalizados na Central de Cadastros?",
  },
  {
    id: "assistant-ai",
    label: "Usar o assistente IA",
    query: "Como usar o Assistente IA do Studio para gerar um processo?",
  },
];

const sectionSearchCache = new Map();

const normalizeText = (value) => {
  if (!value) return "";
  return value
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const getSectionSearchContent = (section) => {
  if (!section) return "";
  if (!sectionSearchCache.has(section.id)) {
    const content = [
      section.title,
      section.summary,
      section.category,
      section.audience,
      section.journeyStage,
      ...(section.whenToUse || []),
      ...(section.steps || []),
      ...(section.tips || []),
      ...(section.related || []),
    ]
      .join(" ")
      .trim();
    sectionSearchCache.set(section.id, normalizeText(content));
  }
  return sectionSearchCache.get(section.id) || "";
};

const tokenizeQuestion = (question) => {
  if (!question) return [];
  return normalizeText(question)
    .split(/[^a-z0-9]+/)
    .filter((token) => token && token.length >= 3);
};

const rankSectionsForQuestion = (question) => {
  const trimmed = question ? question.trim() : "";
  if (!trimmed) {
    return [];
  }

  const normalizedQuestion = normalizeText(trimmed);
  const tokens = tokenizeQuestion(trimmed);

  return MANUAL_SECTIONS.map((section, index) => {
    const searchContent = getSectionSearchContent(section);
    const normalizedTitle = normalizeText(section.title);
    let score = 0;

    if (normalizedQuestion.length >= 4 && searchContent.includes(normalizedQuestion)) {
      score += 10;
    }

    if (normalizedTitle && normalizedQuestion.includes(normalizedTitle)) {
      score += 6;
    }

    tokens.forEach((token) => {
      if (!token) return;
      if (normalizedTitle.includes(token)) {
        score += 5;
      }
      if (searchContent.includes(token)) {
        score += 3;
      }
    });

    if (section.category && normalizedQuestion.includes(normalizeText(section.category))) {
      score += 2;
    }

    if (section.audience && normalizedQuestion.includes(normalizeText(section.audience))) {
      score += 1;
    }

    return { section, score, index };
  })
    .filter((entry) => entry.score > 0)
    .sort((a, b) => {
      if (b.score !== a.score) {
        return b.score - a.score;
      }
      return a.index - b.index;
    });
};

const audiences = [
  { key: "Todos", label: "Todos", icon: <FaUserFriends /> },
  { key: "Colaboradores", label: "Colaboradores", icon: <FaUserFriends /> },
  { key: "Gestores", label: "Gestores", icon: <FaUserTie /> },
  { key: "Administradores", label: "Administradores", icon: <FaUserShield /> },
  { key: "Financeiro", label: "Time financeiro", icon: <FaMoneyCheckAlt /> },
  { key: "TI", label: "Equipe de TI", icon: <FaNetworkWired /> },
];

const journeyStages = ["Início rápido", "Execução diária", "Administração"];

function getAudienceIcon(audience) {
  const match = audiences.find((item) => item.key === audience);
  return match?.icon || <FaUserFriends />;
}

export default function UserManual() {
  const [search, setSearch] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState("Todos");
  const [selectedJourneyStage, setSelectedJourneyStage] = useState("Todos");
  const [assistantQuestion, setAssistantQuestion] = useState("");
  const [assistantConversation, setAssistantConversation] = useState([
    {
      role: "assistant",
      text:
        "Olá! Eu sou a especialista digital do manual. Faça uma pergunta ou escolha uma sugestão abaixo para encontrar o conteúdo certo.",
    },
  ]);
  const [assistantThinking, setAssistantThinking] = useState(false);

  const appendAssistantMessage = useCallback((message) => {
    setAssistantConversation((prev) => {
      const next = [...prev, message];
      return next.length > 12 ? next.slice(next.length - 12) : next;
    });
  }, []);

  const buildAssistantResponse = useCallback((question) => {
    const trimmed = question.trim();
    if (!trimmed) {
      return {
        text:
          "Preciso de uma pergunta ou palavra-chave para pesquisar. Experimente mencionar conciliação, estoque, cadastros ou outro módulo do sistema.",
        matches: [],
      };
    }

    const ranked = rankSectionsForQuestion(trimmed);
    if (!ranked.length) {
      return {
        text:
          "Ainda não encontrei uma resposta direta no manual. Ajuste a pergunta ou tente outro termo relacionado ao módulo desejado.",
        matches: [],
      };
    }

    const topMatches = ranked.slice(0, 3);
    const bestSection = topMatches[0]?.section;

    const lines = [];
    lines.push(
      topMatches.length === 1
        ? "Encontrei 1 seção relevante no manual."
        : `Encontrei ${topMatches.length} seções relevantes no manual.`
    );

    if (bestSection) {
      lines.push(`Principal: ${bestSection.title} — ${bestSection.summary}`);

      if (bestSection.whenToUse?.length) {
        lines.push("Quando utilizar:");
        bestSection.whenToUse.forEach((item) => {
          lines.push(`• ${item}`);
        });
      }

      if (bestSection.steps?.length) {
        const highlightedSteps = bestSection.steps.slice(0, 3);
        lines.push("Passos iniciais:");
        highlightedSteps.forEach((step, index) => {
          lines.push(`${index + 1}. ${step}`);
        });
        if (bestSection.steps.length > highlightedSteps.length) {
          lines.push("Abra a seção completa para consultar todos os passos e boas práticas.");
        }
      }

      if (bestSection.tips?.length) {
        lines.push(`Dica rápida: ${bestSection.tips[0]}`);
      }
    }

    if (topMatches.length > 1) {
      lines.push("Outras seções relacionadas:");
      topMatches.slice(1).forEach((entry, index) => {
        lines.push(`• ${index + 2}. ${entry.section.title} — ${entry.section.summary}`);
      });
    }

    return {
      text: lines.join("\n"),
      matches: topMatches.map((entry) => ({
        id: entry.section.id,
        title: entry.section.title,
        summary: entry.section.summary,
      })),
    };
  }, []);

  const handleRunAssistant = useCallback(
    (rawQuestion) => {
      const trimmed = rawQuestion.trim();
      if (!trimmed) {
        return;
      }
      appendAssistantMessage({ role: "user", text: trimmed });
      setAssistantThinking(true);
      setTimeout(() => {
        const response = buildAssistantResponse(trimmed);
        appendAssistantMessage({
          role: "assistant",
          text: response.text,
          matches: response.matches,
        });
        setAssistantThinking(false);
      }, 120);
    },
    [appendAssistantMessage, buildAssistantResponse],
  );

  const handleAssistantSubmit = useCallback(
    (event) => {
      event.preventDefault();
      const trimmed = assistantQuestion.trim();
      if (!trimmed) {
        return;
      }
      setAssistantQuestion("");
      handleRunAssistant(trimmed);
    },
    [assistantQuestion, handleRunAssistant],
  );

  const handleQuickPrompt = useCallback(
    (prompt) => {
      if (!prompt) {
        return;
      }
      setAssistantQuestion("");
      handleRunAssistant(prompt);
    },
    [handleRunAssistant],
  );

  const scrollToSection = useCallback((sectionId) => {
    if (typeof document === "undefined") {
      return;
    }
    const element = document.getElementById(sectionId);
    if (!element) {
      return;
    }
    element.scrollIntoView({ behavior: "smooth", block: "start" });
    element.classList.add("ring-2", "ring-indigo-300");
    setTimeout(() => {
      element.classList.remove("ring-2", "ring-indigo-300");
    }, 2000);
  }, []);

  const categories = useMemo(() => {
    const unique = new Set();
    MANUAL_SECTIONS.forEach((section) => {
      if (section.category) {
        unique.add(section.category);
      }
    });
    return Array.from(unique);
  }, []);

  const filteredSections = useMemo(() => {
    const term = search.trim().toLowerCase();

    return MANUAL_SECTIONS.filter((section) => {
      const matchesSearch = term
        ? [
            section.title,
            section.summary,
            ...(section.steps || []),
            ...(section.whenToUse || []),
            ...(section.tips || []),
            ...(section.related || []),
          ]
            .join(" ")
            .toLowerCase()
            .includes(term)
        : true;

      const matchesCategory =
        !selectedCategories.length || selectedCategories.includes(section.category);

      const matchesAudience =
        selectedAudience === "Todos" || section.audience === selectedAudience;

      const matchesJourney =
        selectedJourneyStage === "Todos" || section.journeyStage === selectedJourneyStage;

      return matchesSearch && matchesCategory && matchesAudience && matchesJourney;
    });
  }, [search, selectedAudience, selectedCategories, selectedJourneyStage]);

  const smartSuggestions = useMemo(() => {
    const baseList = filteredSections.length ? filteredSections : MANUAL_SECTIONS;
    const priorityAudience =
      selectedAudience !== "Todos"
        ? baseList.filter((section) => section.audience === selectedAudience)
        : baseList;
    return priorityAudience.slice(0, 3);
  }, [filteredSections, selectedAudience]);

  const toggleCategory = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((item) => item !== category) : [...prev, category]
    );
  };

  const resetFilters = () => {
    setSearch("");
    setSelectedCategories([]);
    setSelectedAudience("Todos");
    setSelectedJourneyStage("Todos");
  };

  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold">Manual do Usuário</h1>
        <p className="text-gray-600">
          Explore cada funcionalidade da plataforma BPM com orientações práticas, pré-requisitos e
          sugestões personalizadas conforme o seu perfil de acesso.
        </p>
      </header>

      <section className="space-y-4 rounded-2xl border border-indigo-100 bg-gradient-to-br from-white via-indigo-50 to-blue-50 p-5 shadow">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
          <div className="space-y-2">
            <h2 className="flex items-center gap-2 text-xl font-semibold text-slate-900">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 text-white shadow">
                <FaRobot />
              </span>
              Assistente IA do manual
            </h2>
            <p className="text-sm text-slate-600">
              Faça perguntas em linguagem natural ou selecione uma sugestão para encontrar o passo a passo ideal em segundos.
            </p>
          </div>
          <div className="rounded-xl bg-white/80 px-4 py-2 text-xs font-medium text-indigo-600 shadow-inner">
            {assistantThinking
              ? "Analisando conteúdo do manual..."
              : `${Math.max(assistantConversation.length - 1, 0)} interações registradas`}
          </div>
        </div>

        <div className="space-y-4">
          <div className="max-h-72 space-y-3 overflow-y-auto rounded-2xl border border-indigo-100 bg-white/80 p-4">
            {assistantConversation.map((message, index) => (
              <div
                key={`${message.role}-${index}`}
                className={`flex ${message.role === "user" ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`max-w-xl rounded-2xl px-4 py-3 text-sm shadow ${
                    message.role === "user"
                      ? "bg-indigo-600 text-white"
                      : "bg-indigo-50 text-slate-700"
                  }`}
                >
                  {message.text.split("\n").map((line, lineIndex) => (
                    <p key={lineIndex} className="whitespace-pre-wrap">
                      {line}
                    </p>
                  ))}
                  {message.matches?.length ? (
                    <div className="mt-3 space-y-2">
                      {message.matches.map((match) => (
                        <button
                          key={match.id}
                          type="button"
                          onClick={() => scrollToSection(match.id)}
                          className="w-full rounded-xl border border-indigo-100 bg-white px-3 py-2 text-left text-sm text-indigo-600 transition hover:border-indigo-300 hover:bg-indigo-50"
                        >
                          <div className="font-semibold">{match.title}</div>
                          <div className="text-xs text-slate-500">{match.summary}</div>
                        </button>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
            {assistantThinking && (
              <div className="flex justify-start">
                <div className="rounded-2xl bg-indigo-50 px-4 py-3 text-sm text-slate-700 shadow">
                  Estou analisando o manual...
                </div>
              </div>
            )}
          </div>

          <form onSubmit={handleAssistantSubmit} className="flex flex-col gap-3 md:flex-row md:items-center">
            <label className="relative flex-1">
              <span className="sr-only">Pergunte ao assistente do manual</span>
              <FaQuestionCircle className="pointer-events-none absolute left-3 top-3 text-indigo-400" />
              <input
                type="text"
                value={assistantQuestion}
                onChange={(event) => setAssistantQuestion(event.target.value)}
                placeholder="Como conciliar o financeiro, exportar cadastros ou usar o assistente IA?"
                className="w-full rounded-full border border-indigo-200 bg-white px-10 py-2 text-sm text-slate-700 shadow focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100"
              />
            </label>
            <button
              type="submit"
              disabled={!assistantQuestion.trim()}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Perguntar
              <FaPaperPlane className="text-xs" />
            </button>
          </form>

          <div className="flex flex-wrap gap-2">
            {assistantQuickPrompts.map((prompt) => (
              <button
                key={prompt.id}
                type="button"
                onClick={() => handleQuickPrompt(prompt.query)}
                className="rounded-full border border-indigo-200 bg-white px-4 py-2 text-xs font-medium text-indigo-600 shadow-sm transition hover:border-indigo-300 hover:bg-indigo-50"
              >
                {prompt.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="space-y-4 rounded-lg bg-white p-4 shadow">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-4">
          <label className="relative flex-1">
            <span className="sr-only">Pesquisar no manual</span>
            <FaSearch className="absolute left-3 top-3 text-gray-400" />
            <input
              type="search"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Busque por processos, formulários, agenda, auditoria..."
              className="w-full rounded-lg border py-2 pl-10 pr-3 focus:outline-none focus:ring focus:ring-indigo-100"
            />
            {search && (
              <button
                type="button"
                onClick={() => setSearch("")}
                className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
                aria-label="Limpar busca"
              >
                <FaTimesCircle />
              </button>
            )}
          </label>

          <div className="flex flex-wrap gap-2">
            {journeyStages.map((stage) => (
              <button
                key={stage}
                type="button"
                onClick={() =>
                  setSelectedJourneyStage((current) =>
                    current === stage ? "Todos" : stage
                  )
                }
                className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                  selectedJourneyStage === stage
                    ? "bg-indigo-600 text-white shadow"
                    : "border border-indigo-200 text-indigo-600 hover:bg-indigo-50"
                }`}
              >
                {stage}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => toggleCategory(category)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                selectedCategories.includes(category)
                  ? "bg-slate-900 text-white shadow"
                  : "border border-slate-200 text-slate-700 hover:bg-slate-100"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {audiences.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => setSelectedAudience((current) => (current === option.key ? "Todos" : option.key))}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition ${
                selectedAudience === option.key
                  ? "bg-emerald-600 text-white shadow"
                  : "border border-emerald-200 text-emerald-700 hover:bg-emerald-50"
              }`}
            >
              {option.icon}
              {option.label}
            </button>
          ))}
        </div>

        <div className="flex items-center justify-between text-sm text-slate-500">
          <span>
            {filteredSections.length} {filteredSections.length === 1 ? "resultado" : "resultados"}{" "}
            encontrados
          </span>
          <button
            type="button"
            onClick={resetFilters}
            className="text-indigo-600 hover:text-indigo-800"
          >
            Limpar filtros
          </button>
        </div>
      </section>

      <section className="rounded-lg bg-white p-4 shadow">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-medium">Sugestões inteligentes</h2>
          <span className="text-sm text-gray-500">
            Baseadas no perfil selecionado e nos filtros aplicados
          </span>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          {smartSuggestions.map((section) => (
            <article
              key={section.id}
              className="rounded-lg border border-gray-100 bg-gradient-to-br from-white to-gray-50 p-4 shadow-sm"
            >
              <h3 className="text-base font-semibold text-indigo-600">{section.title}</h3>
              <p className="mt-2 text-sm text-gray-600">{section.summary}</p>
              <div className="mt-3 flex flex-wrap gap-2 text-xs text-gray-500">
                <span className="rounded-full bg-indigo-50 px-2 py-1 text-indigo-600">
                  {section.category}
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-1 text-emerald-600">
                  {getAudienceIcon(section.audience)}
                  {section.audience}
                </span>
                <span className="rounded-full bg-sky-50 px-2 py-1 text-sky-600">
                  {section.journeyStage}
                </span>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        {filteredSections.map((section) => (
          <article key={section.id} id={section.id} className="rounded-lg bg-white p-5 shadow">
            <div className="flex flex-col gap-3 border-b border-gray-100 pb-3 md:flex-row md:items-start md:justify-between">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">{section.title}</h2>
                <p className="mt-1 text-gray-600">{section.summary}</p>
              </div>
              <div className="flex flex-wrap gap-2 text-sm">
                <span className="flex items-center gap-1 rounded-full bg-indigo-50 px-3 py-1 text-indigo-600">
                  {section.category}
                </span>
                <span className="flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-emerald-600">
                  {getAudienceIcon(section.audience)}
                  {section.audience}
                </span>
                <span className="flex items-center gap-1 rounded-full bg-sky-50 px-3 py-1 text-sky-600">
                  {section.journeyStage}
                </span>
              </div>
            </div>

            {section.illustration && (
              <div className="mt-4 flex justify-center md:justify-start">
                <img
                  src={section.illustration}
                  alt={`Ilustração do tópico ${section.title}`}
                  loading="lazy"
                  className="w-full max-w-xs rounded-2xl border border-slate-100 shadow-sm"
                />
              </div>
            )}

            <div className="mt-4 grid gap-4 md:grid-cols-2">
              <div className="space-y-2">
                <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                  <FaCheckCircle className="text-emerald-500" /> Quando utilizar
                </h3>
                <ul className="list-disc space-y-1 pl-5 text-sm text-gray-700">
                  {(section.whenToUse || []).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                  <FaLightbulb className="text-amber-500" /> Passo a passo
                </h3>
                <ol className="space-y-1 pl-5 text-sm text-gray-700">
                  {(section.steps || []).map((step) => (
                    <li key={step} className="list-decimal">
                      {step}
                    </li>
                  ))}
                </ol>
              </div>
            </div>

            {section.tips?.length ? (
              <div className="mt-4 rounded-lg border border-amber-100 bg-amber-50 p-4 text-sm text-amber-700">
                <h4 className="mb-2 font-semibold uppercase tracking-wide">Boas práticas</h4>
                <ul className="list-disc space-y-1 pl-5">
                  {section.tips.map((tip) => (
                    <li key={tip}>{tip}</li>
                  ))}
                </ul>
              </div>
            ) : null}

            {section.related?.length ? (
              <div className="mt-4 text-sm text-gray-500">
                <span className="font-medium text-gray-600">Funcionalidades relacionadas:</span>
                <span className="ml-2">{section.related.join(", ")}</span>
              </div>
            ) : null}
          </article>
        ))}

        {!filteredSections.length && (
          <div className="rounded-lg border border-dashed border-gray-300 bg-white p-6 text-center text-gray-500">
            <p className="font-medium text-gray-600">Nenhum conteúdo corresponde ao filtro atual.</p>
            <p className="mt-1 text-sm">
              Ajuste os filtros acima ou limpe a busca para visualizar todo o manual.
            </p>
          </div>
        )}
      </section>
    </div>
  );
}
